// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBP8WyESIUY6xut5w_WGRsuTwbCGRoHzJo",
  authDomain: "adspace-a0524.firebaseapp.com",
  projectId: "project-352377182815",
  storageBucket: "adspace-a0524.appspot.com",
  messagingSenderId: "352377182815",
  appId: "1:352377182815:web:0a5239fb4c03604a8919ea",
  measurementId: "G-YXH214SNG0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Authentication
const auth = getAuth(app);

// Set up Google provider
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, GoogleAuthProvider };
